export function join(root: string, path: string) {
    const baseUrl = root ? root.replace(/\/$/, '') : '';

    return `${baseUrl}/${path.replace(/^\/+/, '')}`;
}
